export enum PlaygroundDialogType {
  NoInputVariables = "no-input-variables",
  PromptToSaveVersion = "prompt-to-save-version",
}
